/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Built_OnInputs */

const en_marketing_built_on = /** @type {(inputs: Marketing_Built_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built on`)
};

const es_marketing_built_on = /** @type {(inputs: Marketing_Built_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construido sobre`)
};

const fr_marketing_built_on = /** @type {(inputs: Marketing_Built_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construit sur`)
};

/**
* | output |
* | --- |
* | "Built on" |
*
* @param {Marketing_Built_OnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_built_on = /** @type {((inputs?: Marketing_Built_OnInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Built_OnInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_built_on(inputs)
	if (locale === "es") return es_marketing_built_on(inputs)
	return fr_marketing_built_on(inputs)
});